import { render, staticRenderFns } from "./OvertimeItem.vue?vue&type=template&id=3973ebf4&scoped=true"
import script from "./OvertimeItem.vue?vue&type=script&lang=js"
export * from "./OvertimeItem.vue?vue&type=script&lang=js"
import style0 from "./OvertimeItem.vue?vue&type=style&index=0&id=3973ebf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3973ebf4",
  null
  
)

export default component.exports